import { RefObject, useEffect } from 'react'

export const useOnClickOutside = (
    containerRef: RefObject<HTMLElement>,
    callback: () => void,
    options: EventListenerOptions = { capture: true }
) => {
    useEffect(() => {
        const abortController = new AbortController()
        document.addEventListener(
            'mousedown',
            (event: MouseEvent) => {
                if (!containerRef.current || !event.target || !(event.target instanceof Element)) {
                    return
                }

                if (
                    containerRef.current === event.target ||
                    containerRef.current.contains(event.target)
                ) {
                    return
                }

                callback()
            },
            { ...options, signal: abortController.signal }
        )
        return () => abortController.abort()
    }, [containerRef, callback])
}
